import { render, staticRenderFns } from "./ProjectGridItem.vue?vue&type=template&id=8b2d4e7c&scoped=true"
import script from "./ProjectGridItem.vue?vue&type=script&lang=js"
export * from "./ProjectGridItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectGridItem.vue?vue&type=style&index=0&id=8b2d4e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2d4e7c",
  null
  
)

export default component.exports